import ReviewsQueryBase from "@apps/reviews/queries/ReviewsQueryBase";
import ReviewsServiceBase from "@apps/reviews/services/ReviewsServiceBase";

import { ReviewsStateKitQueryWrapper } from "./ReviewsStateKitQueryWrapper";
import { ReviewsStateKitServiceWrapper } from "./ReviewsStateKitServiceWrapper";

export class ReviewsStateKit {
    public readonly query: ReviewsStateKitQueryWrapper;
    public readonly service: ReviewsStateKitServiceWrapper;

    constructor(
        reviewsQuery: ReviewsQueryBase,
        reviewsService: ReviewsServiceBase
    ) {
        this.query = new ReviewsStateKitQueryWrapper(reviewsQuery);
        this.service = new ReviewsStateKitServiceWrapper(
            reviewsQuery,
            reviewsService
        );
    }
}
